import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardTitle, CardText, Button, Container, Row, Col } from 'reactstrap';
import { BASE_URL } from '../../constants';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function ListPackages() {
    const [packages, setPackages] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [stripePromise, setStripePromise] = useState(null);
    const [clientSecret, setClientSecret] = useState('');
    console.log(clientSecret, stripePromise, 'hello')
    console.log(selectedPackage, 'selectedPackage')
    const location = useLocation();
    const token = localStorage.getItem('token');

    const rawUserData = localStorage.getItem('userData');
    const userData = rawUserData && rawUserData !== 'undefined' && rawUserData !== 'null'
        ? JSON.parse(rawUserData)
        : null;

    const userId = userData?.id ?? location?.state?.userData?.user_id;
    const navigate = useNavigate();

    console.log(userId, 'hadi')

    const options = {
        clientSecret: clientSecret,
    };

    const goToNext = () => {
        if (currentIndex < packages.length - 3) {
            setCurrentIndex(currentIndex + 3);
        }
    };

    const goToPrevious = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 3);
        }
    };

    const handleCancel = () => {
        setSelectedPackage(null)
        if (userData) {
            navigate('/account')
        }
        else {
            navigate('/login')
        }
    };

    const fetchPaymentDetails = async () => {
        try {
            const response = await fetch(`${BASE_URL}/payment/sheet/${userId}`);
            const data = await response.json();

            if (data.status) {
                const { setupIntent, publishableKey } = data.result;
                setClientSecret(setupIntent);
                setStripePromise(loadStripe(publishableKey));
            } else {
                console.error("Error: Unable to fetch payment details.");
            }
        } catch (error) {
            console.error("Error fetching payment details:", error);
        }
    };

    const fetchData = () => {
        fetch(`${BASE_URL}/package/list/`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(response => response.json())
            .then(data => {
                if (data.status) {
                    const formattedPackages = data.result.data.map(pckg => ({
                        id: pckg.id,
                        title: pckg.title,
                        price: `$${pckg.amount}/mo`,
                        description: pckg.description,
                        details: [
                            pckg.allowed_properties === 0
                                ? "Unlimited Properties"
                                : `Up to ${pckg.allowed_properties} properties`,
                            pckg.allowed_users === 0
                                ? "Unlimited Managers/Users"
                                : `${pckg.allowed_users} Additional Manager/User`,
                            pckg.has_trial ? `Trial: ${pckg.trial_days} days` : null
                        ].filter(detail => detail !== null)
                    }));
                    setPackages(formattedPackages);
                } else {
                    console.error("Error: Unable to fetch packages data.");
                }
            })
            .catch(error => console.error("Error fetching data:", error));

    };

    useEffect(() => {
        fetchData();
        fetchPaymentDetails();
    }, []);

    if (selectedPackage) {
        return (
            <div style={{ minHeight: '100vh', background: 'rgb(244, 243, 239)', paddingTop: '5%' }}>
                <Container>
                    <h3 className="text-center mb-1" style={{ color: 'grey' }}>Payment for {selectedPackage.title}</h3>
                    {stripePromise && clientSecret && (
                        <Elements stripe={stripePromise} options={options}>
                            <CheckoutForm selectedPackage={selectedPackage} userId={userId} handleCancel={handleCancel} />
                        </Elements>
                    )}
                </Container>
            </div>
        );
    }

    return (
        <div style={{ minHeight: '100vh', background: 'rgb(244, 243, 239)', paddingTop: '5%' }} >
            <Container>
                <h3 className="text-center mb-4" style={{ color: 'grey' }}>Choose a plan</h3>
                <Row className="align-items-center">
                    <Col md="1">
                        <Button style={{ backgroundColor: 'rgba(80,140,253,1.0)', color: 'white' }} onClick={goToPrevious} disabled={currentIndex === 0}>&lt;</Button>
                    </Col>
                    <Col md="10">
                        <Row className="my-5">
                            {packages.slice(currentIndex, currentIndex + 3).map((pkg, index) => (
                                <Col md="4" key={index}>
                                    <Card className="mb-4 h-100" style={{ backgroundColor: 'rgba(80,140,253,1.0)', color: 'white' }}>
                                        <CardBody className="text-center d-flex flex-column justify-content-between">
                                            <div>
                                                <CardTitle tag="h5" style={{ color: 'white' }}>{pkg.price}</CardTitle>
                                                <h6 style={{ color: 'white' }}>{pkg.title}</h6>
                                                <CardText style={{ color: 'white' }}>{pkg.description}</CardText>
                                            </div>
                                            <ul className="list-unstyled">
                                                {pkg.details.map((detail, i) => (
                                                    <li key={i}>{detail}</li>
                                                ))}
                                            </ul>
                                            <Button
                                                style={{ color: 'rgba(80,140,253,1.0)', backgroundColor: 'white', marginTop: 'auto' }}
                                                onClick={() => setSelectedPackage(pkg)}
                                            >
                                                Subscribe
                                            </Button>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                    <Col md="1">
                        <Button style={{ backgroundColor: 'rgba(80,140,253,1.0)', color: 'white' }} onClick={goToNext} disabled={currentIndex >= packages.length - 3}>&gt;</Button>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default ListPackages;
